import { render, staticRenderFns } from "./courseHourResource.vue?vue&type=template&id=73c190ee&scoped=true"
import script from "./courseHourResource.vue?vue&type=script&lang=js"
export * from "./courseHourResource.vue?vue&type=script&lang=js"
import style0 from "./courseHourResource.vue?vue&type=style&index=0&id=73c190ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c190ee",
  null
  
)

export default component.exports